var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "csv-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "csv-icon-group2",
    transform: "translate(-92.000000, -314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "csv-icon-group3",
    transform: "translate(92.000000, 314.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "csv-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5405405,25.8498498 L28.5405405,7.01501502 C28.5405405,5.53513514 27.3297297,4.32432432 25.8498498,4.32432432 L7.01501502,4.32432432 C5.53513514,4.32432432 4.32432432,5.53513514 4.32432432,7.01501502 L4.32432432,25.8498498 C4.32432432,27.3297297 5.53513514,28.5405405 7.01501502,28.5405405 L25.8498498,28.5405405 C27.3297297,28.5405405 28.5405405,27.3297297 28.5405405,25.8498498 Z",
    id: "csv-icon-path1",
    fill: "#08743B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "csv-icon-polygon2",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "17.4285714 11 24.4285714 11 24.4285714 13.4 17.4285714 13.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "csv-icon-polygon3",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "15.3850932 11 15.3850932 13.4 8.38509317 13.4 8.38509317 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "csv-icon-polygon4",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "17.4285714 15.4 24.4285714 15.4 24.4285714 17.8 17.4285714 17.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "csv-icon-polygon5",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "15.3850932 15.4 15.3850932 17.8 8.38509317 17.8 8.38509317 15.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "csv-icon-polygon6",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "24.4285714 19.8 24.4285714 22.2 17.4285714 22.2 17.4285714 19.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "csv-icon-polygon7",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "15.3850932 19.8 15.3850932 22.2 8.38509317 22.2 8.38509317 19.8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv-icon.4da9b84f.svg";
export { ForwardRef as ReactComponent };